var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowingCrop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_733_9763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.60168 53.648C4.4911 53.032 5.39145 52.416 6.30282 51.8336C8.29027 50.5456 10.3436 49.336 12.4409 48.216C14.5381 47.096 16.7232 46.032 18.9303 45.0688C21.1373 44.1056 23.4652 43.2208 25.804 42.4368C34.4858 39.5147 43.5639 38.0029 52.706 37.9568",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8918 53.648C24.3246 46.3934 38.3829 42.5356 52.7059 42.448",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6863 53.648C31.4684 49.2728 42.0248 46.9859 52.7059 46.928",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.706 51.4192C46.8157 51.449 40.9504 52.201 35.2362 53.6592",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 37.9568H52.7059",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 42.4368H25.7161",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 46.9169H14.8675",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9806 36.8481V36.4561C38.9661 32.3592 40.5457 28.4239 43.3727 25.5137",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5358 23.6509C54.2759 20.856 55.0893 17.1542 53.3526 15.3828C51.6159 13.6114 47.9868 14.4411 45.2467 17.236C42.5066 20.0309 41.6931 23.7326 43.4298 25.5041C45.1665 27.2755 48.7957 26.4458 51.5358 23.6509Z",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9804 36.8481V36.4561C38.9949 32.3592 37.4153 28.4239 34.5883 25.5137",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5324 25.5038C36.2691 23.7324 35.4557 20.0306 32.7156 17.2357C29.9755 14.4408 26.3463 13.6111 24.6096 15.3825C22.8729 17.154 23.6864 20.8557 26.4265 23.6506C29.1666 26.4455 32.7957 27.2752 34.5324 25.5038Z",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9803 16.6768C41.4363 16.6768 43.4273 13.4726 43.4273 9.51996C43.4273 5.56737 41.4363 2.36316 38.9803 2.36316C36.5242 2.36316 34.5332 5.56737 34.5332 9.51996C34.5332 13.4726 36.5242 16.6768 38.9803 16.6768Z",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9805 16.6768V37.5199",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.396 25.6368V37.9568",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6941 27.8768V37.9568",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6078 27.8768V37.9568",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.24719 28.9968V37.9568",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8431 31.2368V37.9568",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1177 31.2368V37.9568",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.09814 31.2368V37.9568",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.545 22.2769V37.9569",
    stroke: "#407D41",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_733_9763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowingCrop);
export default __webpack_public_path__ + "static/media/growingCrop.63084d48377a0909dede8ecd7675f333.svg";
export { ForwardRef as ReactComponent };